import debug from 'debug';
import { fromLatLon } from 'utm';

var log = debug("xpedeo-core:FraunhoferPositionEngine");
debug.enable(process.env.VUE_APP_DEBUG || "");

var FraunhoferPositionEngine =
/** @class */
function () {
  function FraunhoferPositionEngine() {
    this.isListening = false;
    this.subscribers = [];
  }

  FraunhoferPositionEngine.prototype.getLastPosition = function () {
    return this.lastPosition;
  };

  FraunhoferPositionEngine.prototype.getIsListening = function () {
    return this.isListening;
  };

  FraunhoferPositionEngine.prototype.getSubscribers = function () {
    return this.subscribers;
  };

  FraunhoferPositionEngine.prototype.subscribe = function (callback) {
    if (!this.subscribers.includes(callback)) {
      this.subscribers.push(callback);
    } else {
      throw new Error("this callback has already subscribed to GpsEngine.");
    }
  };

  FraunhoferPositionEngine.prototype.unsubscribe = function (callback) {
    if (this.subscribers.includes(callback)) {
      this.subscribers = this.subscribers.filter(function (item) {
        return item !== callback;
      });
    } else {
      throw new Error("this callback does not exist in GpsEngine's subscribers.");
    }
  };

  FraunhoferPositionEngine.prototype.start = function () {
    log("start listening in FraunhoferPositionEngine"); // replace with Fraunhofer init logic (the method from the plugin to build)

    window.Fraunhofer.start(this.notify.bind(this), this.onError.bind(this)); // this.watcherId = navigator.geolocation.watchPosition(this.parsePositionAndNotify.bind(this));

    this.isListening = true;
    return true;
  };

  FraunhoferPositionEngine.prototype.stop = function () {
    log("stop listening in FraunhoferPositionEngine");
    window.Fraunhofer.stop(function () {
      log("stopped successfully");
    }, this.onError.bind(this)); // replace with Fraunhofer stop logic (the method from the plugin to build)
    // navigator.geolocation.clearWatch(this.watcherId);

    this.isListening = false;
    return true;
  };

  FraunhoferPositionEngine.prototype.notify = function (info) {
    // log(`notify`, info);
    this.lastPosition = info;

    for (var _i = 0, _a = this.subscribers; _i < _a.length; _i++) {
      var cb = _a[_i];
      cb(info);
    }
  };

  FraunhoferPositionEngine.prototype.onError = function (error) {
    log("Error has happened.", error);
  };

  return FraunhoferPositionEngine;
}();

var log$1 = debug("xpedeo-core:GpsEngine");
debug.enable(process.env.VUE_APP_DEBUG || "");

var GpsEngine =
/** @class */
function () {
  function GpsEngine() {
    this.isListening = false;
    this.subscribers = [];
  }

  GpsEngine.prototype.getLastPosition = function () {
    return this.lastGpsPosition;
  };

  GpsEngine.prototype.getIsListening = function () {
    return this.isListening;
  };

  GpsEngine.prototype.getSubscribers = function () {
    return this.subscribers;
  };

  GpsEngine.prototype.subscribe = function (callback) {
    if (!this.subscribers.includes(callback)) {
      this.subscribers.push(callback);
    } else {
      throw new Error("this callback has already subscribed to GpsEngine.");
    }
  };

  GpsEngine.prototype.unsubscribe = function (callback) {
    if (this.subscribers.includes(callback)) {
      this.subscribers = this.subscribers.filter(function (item) {
        return item !== callback;
      });
    } else {
      throw new Error("this callback does not exist in GpsEngine's subscribers.");
    }
  };

  GpsEngine.prototype.start = function () {
    log$1("start listening in GpsEngine");
    this.watcherId = navigator.geolocation.watchPosition(this.parsePositionAndNotify.bind(this));
    this.isListening = true;
    return true;
  };

  GpsEngine.prototype.stop = function () {
    log$1("stop listening in GpsEngine");
    navigator.geolocation.clearWatch(this.watcherId);
    this.isListening = false;
    return true;
  };

  GpsEngine.prototype.parsePositionAndNotify = function (position) {
    var utmPosition = fromLatLon(position.coords.latitude, position.coords.longitude);
    var info = {
      accuracy: position.coords.accuracy,
      easting: utmPosition.easting,
      height: position.coords.altitude,
      northing: utmPosition.northing,
      quality: -1,
      siteName: null,
      timestamp: position.timestamp
    };
    this.lastGpsPosition = info;
    this.notify(info);
  };

  GpsEngine.prototype.notify = function (info) {
    log$1("notify", info);

    for (var _i = 0, _a = this.subscribers; _i < _a.length; _i++) {
      var cb = _a[_i];
      cb(info);
    }
  };

  return GpsEngine;
}();

var log$2 = debug("xpedeo-core:PseudoEngine");
debug.enable(process.env.VUE_APP_DEBUG || "");

var PseudoEngine =
/** @class */
function () {
  function PseudoEngine() {}

  PseudoEngine.prototype.getLastPosition = function () {
    return this.lastPseudoPosition;
  };

  PseudoEngine.prototype.setPseudoCoordination = function (coords) {
    this.lastPseudoPosition = coords;
  };
  /**
   * @depredated
   */


  PseudoEngine.prototype.getPseudoCoordination = function () {
    return this.lastPseudoPosition;
  };

  PseudoEngine.prototype.getIsListening = function () {
    return false;
  };

  PseudoEngine.prototype.start = function () {
    return true;
  };

  PseudoEngine.prototype.stop = function () {
    return true;
  };

  PseudoEngine.prototype.getSubscribers = function () {
    return [];
  };

  PseudoEngine.prototype.subscribe = function (callback) {
    throw new Error("Method not implemented.");
  };

  PseudoEngine.prototype.unsubscribe = function (callback) {
    throw new Error("Method not implemented.");
  };

  PseudoEngine.prototype.notify = function (info) {
    throw new Error("Method not implemented.");
  };

  return PseudoEngine;
}();

var log$3 = debug("xpedeo-core:positioning");
debug.enable(process.env.VUE_APP_DEBUG || "");
var positioningPlugin = {
  __engines: new Map(),
  getEngine: function getEngine(type) {
    return this.__engines.get(type);
  },
  install: function install(Vue, opts, $xp, cfg) {
    log$3("installing positioning plugin");

    if ($xp.positioningInstalled) {
      return;
    }

    $xp.positioningInstalled = true; // initialize engines based on plugin options

    this.__engines.set("GPS"
    /* GPS */
    , new GpsEngine());

    if (cfg.engines) {
      for (var _i = 0, _a = cfg.engines; _i < _a.length; _i++) {
        var engine = _a[_i];

        switch (engine) {
          case "pseudo":
            this.__engines.set("Pseudo"
            /* PSEUDO */
            , new PseudoEngine());

            break;

          case "FraunhoferPosition":
            this.__engines.set("FraunhoferPosition"
            /* FraunhoferPosition */
            , new FraunhoferPositionEngine());

            break;

          default:
            throw new Error(engine + " is invalid positioning engine");
        }
      }
    }

    Vue.util.defineReactive($xp, "positioning", this);
  }
};

export default positioningPlugin;
